import type { ServiceResponse } from "../core/service";
import type {
  DelegationCreateRequest,
  DelegationCreateResponse,
  DelegationStatusRequest,
  DelegationStatusResponse,
} from "../schemas/delegation";

import { BaseService } from "../core/service";
import {
  delegationCreateResponseSchema,
  delegationStatusResponseSchema,
} from "../schemas/delegation";

export class DelegationService extends BaseService {
  public async getStatus(
    data: DelegationStatusRequest,
  ): Promise<ServiceResponse<DelegationStatusResponse>> {
    return this.get("/delegation/status", {
      data,
      responseSchema: delegationStatusResponseSchema,
    });
  }

  public async create(
    requestBody: DelegationCreateRequest,
  ): Promise<ServiceResponse<DelegationCreateResponse>> {
    return this.post("/delegation/new", {
      data: requestBody,
      responseSchema: delegationCreateResponseSchema,
    });
  }
}
